function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M30.5,36.1c-2.8,0-5.4-1.9-7.5-5.2c-1.7-2.8-2.8-6.3-2.8-9.1c0-5.9,4.6-10.6,10.3-10.6c5.7,0,10.3,4.8,10.3,10.6 c0,2.8-1.1,6.3-2.8,9.1C35.9,34.2,33.2,36.1,30.5,36.1z M30.5,14.2c-4,0-7.3,3.4-7.3,7.6c0,4.7,3.7,11.3,7.3,11.3 c3.6,0,7.3-6.6,7.3-11.3C37.8,17.6,34.5,14.2,30.5,14.2z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "49.9,45.6 9.9,45.6 9.9,37.1 24,29.8 25.3,32.5 12.9,38.9 12.9,42.6 46.8,42.6 46.8,39.1 35.1,33.1 36.5,30.4  49.9,37.2  "
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "59.7,59.7 44.5,59.7 44.5,56.7 56.7,56.7 56.7,43.5 59.7,43.5  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "59.7,15.2 56.7,15.2 56.7,3 44.5,3 44.5,0 59.7,0  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "3,15.2 0,15.2 0,0 16.2,0 16.2,3 3,3  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "16.2,59.7 0,59.7 0,43.5 3,43.5 3,56.7 16.2,56.7  "
}))))));

var SvgFocusGroup = function SvgFocusGroup(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.7 59.7",
    style: {
      enableBackground: "new 0 0 59.7 59.7"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/focus-group.da4ab426.svg";
export { SvgFocusGroup as ReactComponent };